import styled from 'styled-components';
import { CardPage, Tag, TAX_ROUND_OFF, CurrencyText } from '@nile/components';
import React from 'react';
import { roundToFixed } from '@nile/components/src/Utils/helpers';

const Wrapper = styled.div`
  .Polaris-Page {
    max-width: ${(props) =>
      props.isChatVisible ? 'calc(100% - 520px) !important' : '1400px'};
    width: ${(props) => (props.isChatVisible ? '100%' : '1400px')};
  }
  .Polaris-Page-Header {
    padding: 20px !important;
  }
  .Superops-Page {
    margin: 0 !important;
    max-width: ${(props) =>
      props.isChatVisible ? 'calc(100% - 520px) !important' : '1400px'};
    width: ${(props) => (props.isChatVisible ? '100%' : '1400px')};
  }
  .Superops-Page-Header {
    padding: 20px !important;
  }
  .Superops-Page__Content,
  .Superops-Page--contentPrimary {
    padding: 20px 0 !important;
  }
  .Superops-Heading .Superops-Heading--sizePrimary {
    font-size: 20px !important;
  }
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
  .colHeader {
    padding-left: 8px;
  }
  .Superops-TextField__Input {
    border-bottom: 1px solid #ececec;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField__Input {
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-left: 4px;
  }
  .Superops-Banner__Position {
    width: 100%;
  }
  .red {
    color: red;
  }
  .sk-table-container {
    height: 400px !important;
  }
  .branding-logo {
    margin-bottom: 10px !important;
  }
  .msp-name {
    font-size: 18px !important;
    // margin-left: 10px;
    font-weight: 600;
  }
`;

const DateSection = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container > input {
    width: auto;
  }
`;

const getSubTotal = (d, data) => {
  let sTotal = 0;
  const items = data.items || [];
  items.forEach((el) => {
    sTotal += Number(el.amount);
  });
  return sTotal;
};
const getTaxes = (d, data) => {
  const ROUND_OFF_LIMIT = 2;
  let totalTax = 0;
  // change the taxAmount in tax group by calculating tax for each line item.
  if (data.taxes) {
    data.taxes.forEach((tax, idx) => {
      let taxAmount = 0;
      data.items.forEach((item) => {
        if (
          item.tax &&
          item.tax.rates.some((r) => r.rateId === tax?.rate?.rateId) &&
          item.taxable
        ) {
          const taxRateValue = Number(tax.taxRate) / 100;
          const lineItemTaxAmount = Number(item.amount) * taxRateValue;
          taxAmount += roundToFixed(lineItemTaxAmount, ROUND_OFF_LIMIT);
        }
      });
      totalTax += taxAmount;
    });
  }
  return totalTax;
};
// Calculate additional discount based on discountRate
const getAdditionalDiscount = (sTotal, tRates, data) => {
  let additionalDiscount = 0;
  if (data.additionalDiscount) {
    additionalDiscount = data.additionalDiscount;
  } else if (data.additionalDiscountRate) {
    additionalDiscount =
      ((sTotal + tRates) * Number(data.additionalDiscountRate)) / 100;
  }
  additionalDiscount = Number(parseFloat(additionalDiscount).toFixed(2));
  return additionalDiscount;
};

const getPrefix = (el) => {
  switch (el.type) {
    case 'Tag':
      return (
        <div className="flex jend mr10">
          <Tag>{el.prefix}</Tag>
        </div>
      );
    default:
      return <>{el.prefix}</>;
  }
};

const getValue = (el, countryCode, currencyCode) => {
  switch (el.name) {
    case 'addAdditionalDiscount':
      return '';
    default:
      return <CurrencyText value={el.value} />;
  }
};

const pdfStyles = `
    body {
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: 14px;
    }

    table {
      outline: 1px solid transparent !important;
      border-collapse: collapse;
      border: 1px solid transparent !important;
    }

    thead {
      outline: 1px solid transparent !important;
      border-collapse: collapse;
      border: 1px solid transparent !important;
    }
    thead .tr {
      background: #333;
    }
    tr {
      outline: 1px solid transparent !important;
      border-collapse: collapse;
      border: 1px solid transparent !important;
    }

    td {
      outline: 1px solid transparent !important;
      border-collapse: collapse;
      border: 1px solid transparent !important;
    }

    #invoice-pdf {
      height: 100%;
      -webkit-print-color-adjust: exact;
      page-break-inside: avoid;
      break-inside: avoid;
      width: 990px;
    }
    .table {
      width: 100%;
      font-size: 12px;
      -webkit-print-color-adjust: exact;
    }
    .th {
      break-inside: avoid;
    }
    .thead {
      break-inside: avoid;
    }
    .mt-40 {
      margin-top: 40px;
    }
    .super-pdf-holder {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',sans-serif
    }
    .super-pdf-holder .Polaris-Page {
      max-width: ${(props) =>
        props.isChatVisible ? 'calc(100% - 520px) !important' : '1400px'};
      width: ${(props) => (props.isChatVisible ? '100%' : '1400px')};
    }
    .super-pdf-holder .Polaris-Page-Header {
      padding: 20px !important;
    }
    .super-pdf-holder .Superops-Page {
      max-width: ${(props) =>
        props.isChatVisible ? 'calc(100% - 520px) !important' : '1400px'};
      width: ${(props) => (props.isChatVisible ? '100%' : '1400px')};
    }
    .super-pdf-holder .Superops-Page-Header {
      padding: 20px !important;
    }
    .super-pdf-holder .Superops-Page__Content,
    .super-pdf-holder .Superops-Page--contentPrimary {
      padding: 20px 0 !important;
    }
    .super-pdf-holder .Superops-Heading .Superops-Heading--sizePrimary {
      font-size: 20px !important;
    }
    .super-pdf-holder .Superops-TextField__ActionableSuffix {
      background: ${(props) =>
        props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
      border-radius: 10px 10px 0 0;
      transition: background 200ms linear;
    }
    .super-pdf-holder .colHeader {
      padding-left: 8px;
    }
    .super-pdf-holder .Superops-TextField__Input {
      border-bottom: 1px solid #ececec;
    }
    .super-pdf-holder .Superops-Connected {
      padding-top: 0 !important;
    }
    .super-pdf-holder .Superops-TextField__Input {
      min-height: 38px;
    }
    .super-pdf-holder .Superops-TextField__Input {
      padding-left: 4px;
    }
    .super-pdf-holder .Superops-Banner__Position {
      width: 100%;
    }
    .super-pdf-holder .red {
      color: red;
    }
    .super-pdf-holder .sk-table-container {
      height: 400px !important;
    }
    .super-pdf-holder .branding-logo {
      margin-bottom: 10px !important;
    }
    .super-pdf-holder .msp-name {
      font-size: 18px !important;
      // margin-left: 10px;
      font-weight: 600;
    }

    .full-height {
      height: 100%;
    }
    .bg-white {
      background: #fff;
    }
    .center {
      align-items: center;
    }
    .grid {
      display: grid;
    }
    .flex {
      display: flex;
    }
    .g40 {
      gap: 40px;
    }
    .content-padding {
      padding: 20px 40px;
    }
    .mlauto {
      margin-left: auto;
    }
    .self-start {
      align-self: start;
    }
    .mr-10 {
      margin-right: 10px;
    }
    .col {
      flex-direction: column;
    }
    .aend {
      align-items: flex-end;
    }
    .ml8 {
      margin-left: 8px;
    }
    .uppercase {
      text-transform: uppercase;
    }
    .f-12 {
      font-size: 12px;
    }
    .mt-30 {
      margin-top: 30px;
    }
    .p20 {
      padding: 20px;
    }
    .pb-100 {
      padding-bottom: 100px;
    }
    .avoid-break {
      break-inside: avoid;
    }
    .g20 {
      gap: 20px;
    }
    .pdf-header {
    }
    .pdf-header .invoice-title {
      font-weight: 600;
      font-size: 24px !important;
    }
    .pdf-header .Superops-TextField__Input {
      font-weight: 600;
      font-size: 20px !important;
    }
    .pdf-header .Polaris-Link {
      color: #000 !important;
    }

    .client-info {
      margin-bottom: 10px;
      .site-info {
        line-height: 21px;
      }
    }
    .info {
      line-height: 30px;
    }
    .b2 {
      font-weight: 600;
    }
    .b3t2 {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.6);
    }
    .cost {
      width: 700px;
      font-size: 16px;
    }
    .jend {
      justify-content: flex-end;
    }
    .fb50 {
      flex-basis: 50%;
    }
    .quote-total {
      font-size: 20px;
      margin-left: auto;
      background-color: #f1f6ff;
      border-radius: 10px;
      width: 400px;
    }
    .footer {
      padding: 20px;
      border-top: 1px solid #ececec;
      img {
        max-width: 100%;
      }
    }
    .row {
      line-height: 35px;
      font-weight: 500;
    }
    .cell {
      flex-grow: 1;
      flex-basis: 25%;
    }
    .super-table-container {
      // height: 100%;
    }
    .super-table-container .table {
      min-width: 400px !important;
    }
    .super-table-container .columnHeader {
      flex: none !important;
    }
    .super-table-container .tbody {
      display: inline-block;
      overflow: auto;
      padding-top: 12px;
    }
    .super-table-container .tr {
      min-height: 42px;
    }
    .super-table-container.tr, .super-table-container.td,
    .super-table-container.inblock {
      padding-left: 4px;
    }
    .super-table-container .unFreezeContent {
      width: 99%;
      overflow: auto;
      white-space: nowrap;
      position: relative;
      // padding-left: 20px;
    }
    .super-table-container .unFreezeContent:hover {
      overflow: auto;
    }
    .super-table-container .cell {
      font-weight: ${(props) => (props.notBold ? '400 !important' : '')};
    }
    .super-table-container.table {
      font-size: 12px;
    }
    .super-table-container.colHeader {
      font-size: 10px;
    }
    .table-body-wrapper {
      padding: 0px;
      max-height: calc(100% - 50px) !important;
    }
    .table-body-wrapper .tr {
      cursor: default;
      border: none;
    }
    .table-body-wrapper .td {
      background: #ffffff;
      pointer-events: all;
    }
    .table-styles {
      // height: 100%;
    }
    .block {
      display: block;
    }
    .table-styles .table-content {
      // height: calc(100% - 50px); //reduce header height
    }
    .table-styles .columHeader {
      min-height: 50px;
      height: auto !important;
      padding: 0;
      background: #333;
    }
    // .table-styles .table > thead:first-child > tr:first-child {
    //   display: none !important;
    // }
    .table-styles .unfreezeContent {
      align-items: flex-start;
      position: relative;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .table-styles .unfreezeHeader::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .table-styles .unfreezeHeader {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    .table-styles .columnHeader {
      width: 100%;
    }

    .table-styles .deleteItem {
      visibility: hidden;
    }

    .table-styles .action-button {
      visibility: hidden;
    }

    .table-styles .p-0 {
      padding: 0px !important;
    }

    .table-styles .px-10 {
      padding: 0 10px !important;
    }

    .table-styles .colHeader {
      text-transform: uppercase;
      font-size: 10px;
      color:  rgba(255,255,255,1) ;
      background: #333;
      border-right: 1px solid rgba(255,255,255,0.6);
      height: 50%;
      margin: 4px 0;
      margin-top: 12px;
    }

    .table-styles .tbody {

    }
    .table-styles .tr {
      min-height: 50px !important;
      border-bottom: 1px solid #ececec !important;
    }
    .table-styles .editable-cell {
      border-radius: 4px;
      height: 80%;
      font-weight: normal !important;
      border: 1px solid transparent;
    }
    .table-styles .td {
      background: #ffffff;
      align-items: flex-start !important;
      border-bottom: 1px solid transparent;
      padding: 8px 5px;
    }

    .table-styles .resizer {
      display: inline-block;
      //background: #ececec;
      width: 5px;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(50%);
      z-index: 1;

      touch-action:none;

      &.isResizing {
        background: red;
      }
    }
    .table-styles .unfreezeContent {
      align-items: flex-start;
      position: relative;
    }
    .table-styles .no-data-found-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 100px;
    }
    .table-styles .empty-state-msg {
      font-size: 14px;
      margin-right: 20px;
    }
    .table-styles .table {
      // height: calc(100% - 46px);
      padding-bottom: 10px;
    }
    .table-header-wrapper {
      padding: 0;
      padding-left: 4px;
      min-height: 100%;
    }
    .table-header-wrapper .filter-icon {
      margin-left: auto;
      margin-right: 2px;
      visibility: hidden;
      cursor: pointer;
    }
    .table-header-wrapper .icon {
      visibility: hidden;
      cursor: pointer;
    }
    .table-header-wrapper .action-button {
      visibility: hidden;
    }
    .inblock {
      display: inline-block;
    }
    .table-header-wrapper .header {
      font-weight: normal;
      cursor: auto;
      display: flex;
      align-items: center;
      margin-right: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .table {
      border-collapse: collapse;
      border-spacing: 0;
    }
    .columHeader {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      border-top: 1px solid #dedede;
      border-bottom: 1px solid #dedede;
      box-sizing: border-box;
    }
    .disabled {
      opacity: 0.4
    }
    .status-tag {
      border-radius: 5px;
      font-weight: 500;
      padding: 8px;
      margin-left: 10px;
    }
    .bold {
      font-weight: bold;
    }
    .col {
      flex-direction: column;
    }
    .aend {
      align-items: flex-end;
    }
    .mt-20{
      margin-top: 20px;
    }
    .pr40 {
      padding-right: 40px;
    }
  `;

export {
  DateSection,
  Wrapper,
  getSubTotal,
  getTaxes,
  getAdditionalDiscount,
  getPrefix,
  getValue,
  pdfStyles
};
